import { isNil } from 'lodash';
import { MODULE_PARAM_NAME } from 'config/routes';
import { ACCOUNT_ID } from 'hooks/queryParams/useSelectedAccountId';
import { queryParamHookFactory } from 'modules/taboola-common-frontend-modules/query-params';
import { PERSISTENCE_TYPE } from 'modules/taboola-common-frontend-modules/storage';
import { AllEntityId } from '../config/allEntityId';
import { REPORT_ENTITY_TYPE } from './useReportEntityType';

export const reportEntityIdDeserializer = val => {
    if (isNil(val)) {
        return val;
    }

    const parseVal = parseInt(val);
    if (Number.isNaN(parseVal)) {
        return val;
    }

    return parseVal;
};
export const REPORT_ENTITY_IDS = 'reportEntityIds';

export const useReportEntityIds = queryParamHookFactory(REPORT_ENTITY_IDS, {
    deserializer: reportEntityIdDeserializer,
    persist: PERSISTENCE_TYPE.MEMORY,
    defaultValue: AllEntityId,
    dependencies: {
        queryParams: [ACCOUNT_ID, REPORT_ENTITY_TYPE],
        pathParams: [MODULE_PARAM_NAME],
    },
});
